import { PdfTemplate } from "components";
import moment from "moment";
import { cellValuePdf, RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { FormType, getDifference } from "../utils";
import { useOptionalCountDetailContext } from "../contexts";
import { PropsWithChildren } from "react";
import { TextAlign } from "chart.js";

type ExportPdfCountInventoryProps = {
  countdetail: FormType["countdetail"]
  transaction_date: FormType["transaction_date"]
  getCountDetail: ReturnType<typeof useOptionalCountDetailContext>
}

export function ExportPdfCountInventory(params: PropsWithChildren<ExportPdfCountInventoryProps>) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "ITEM", key: "product_barcode", width: 15 },
    { header: "DESCRIPTION", key: "product_name", width: 30 },
    { header: "UNIT", key: "mr_unit_name", width: 15 },
    { header: "SOH", key: "soh_count", width: 10, align: "center" },
    { header: "COUNT", key: "real_count", width: 15 },
    { header: "DIFFERENT", key: "different", width: 10, textAlign: "center" }
  ]

  const dataMap: RowExportTypePdf[] = params?.countdetail?.map((item, index) => {
    const dataCount = params?.getCountDetail?.data?.countdetail?.find((i) => i?.product_id === item?.product_id)

    return {
      no: index + 1,
      product_barcode: dataCount?.product_barcode || "-",
      product_name: dataCount?.product_name || "-",
      mr_unit_name: dataCount?.mr_unit_name || "-",
      soh_count: item?.soh_count,
      real_count: numberFormat(item?.real_count),
      different: centerFormat(getDifference(item?.soh_count, item?.real_count))
    }
  })

  return (
    <PdfTemplate 
      data={dataMap} 
      module="INVENTORY" 
      title="COUNT INVENTORY ITEM" 
      column={columns as { header: string; key: string | number; width: number; textAlign?: TextAlign }[]} 
      date={`${moment(params?.transaction_date).format('DD-MM-YYYY')}`}
    />
  )
}

function centerFormat(value: number): cellValuePdf {
  return {
    text: convertNumber(value).intoCurrency,
    style: {
      // flex: 1,
      textAlign: "center",
      fontWeight: "bold"
    }
  }
}

function numberFormat(value: number): cellValuePdf {
  return {
    text: convertNumber(value).intoCurrency,
    style: {
      textAlign: "right",
      fontWeight: "bold"
    }
  }
}
